<div class="pb-5 sb-router-outlet__no-header">
  <div class="container text-center pt-3">
    <a class="pt-5" href="https://www.springbot.com">
      <img src="https://springbot-assets.s3.us-east-1.amazonaws.com/images/sb-logo-reverse.png" class="sb-logo">
    </a>
    <h1 class="my-5 register-header white-color">
      Unlock the Full Potential of Your Ecommerce Marketing
    </h1>
    <p  *ngIf="!loading" class="subheader w-75 m-auto mt-3 primary-green-color register-subheader">
      Manage all your marketing channels effortlessly in one place!
    </p>

    <div *ngIf="loading && showLoadingAnimation" class="container text-center pt-3 animate-fade-in">
      <div class="p-3 dashboard-loading-box">
        <img src="https://springbot-assets.s3.amazonaws.com/images/robot-loading.gif" style="max-width:100%">
        <p class="subheader w-75 m-auto mt-3 medium-gray-color">Building your dashboard</p>
      </div>
    </div>

    <div class="text-left register-form-container mt-5" *ngIf="!loading">
      <div class="alert alert-danger" [innerHTML]="error" *ngIf="!!error"></div>
      <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
        <div class="field">
          <label class="form-label">Email address</label><br>
          <input class="form-control" name="email" [ngClass]="{ 'is-invalid' : email.errors && (email.dirty || email.touched) }"
          formControlName="email" type="email" required placeholder="You will use this email to login">
          <div *ngIf="email.invalid && (email.dirty || email.touched)" class="invalid-feedback">
            <span *ngIf="email.errors.required">
              Required
            </span>
            <span *ngIf="email.errors.email">
              Email address is invalid
            </span>
          </div>
        </div>

        <div class="field">
          <label class="form-label">New Password</label><br>
          <input class="form-control" name="password" [ngClass]="{ 'is-invalid' : password.errors && (password.dirty || password.touched) }"
          formControlName="password" type="password" required placeholder="You will use this password to login">
          <div *ngIf="password.invalid && (password.dirty || password.touched)" class="invalid-feedback">
            <span *ngIf="password.errors.required">
              Required
            </span>
            <span *ngIf="password.errors.minlength">
              Password must be at least {{ MINIMUM_PASSWORD_LENGTH }} characters.
            </span>
          </div>
        </div>

        <div class="field">
          <label class="form-label">Your company website</label><br>
          <input class="form-control mb-1" name="website" type="text" formControlName="website" placeholder="https://">

          <div>
            <div class="invalid-feedback" *ngIf="website.invalid && (website.dirty || website.touched) && website.errors && website.errors.required">
              Don't forget to add your company website.
            </div>
            <div class="invalid-feedback" *ngIf="website.invalid && (website.dirty || website.touched) && website.errors && website.errors.pattern?.requiredPattern">
              Please enter a valid URL.
            </div>
          </div>
        </div>

        <div class="field" *ngIf="isProd">
          <re-captcha formControlName="recaptchaReactive"></re-captcha>
          <div *ngIf="submittedForm" class="invalid-feedback">
            <span *ngIf="recaptchaReactive.errors?.required">
              reCAPTCHA is required
            </span>
          </div>
        </div>

        <div class="field">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="agreeToTerms" id="agreeToTerms">
            <label class="form-check-label" for="agreeToTerms">
              I agree to Springbot's <a href="https://springbot.com/terms-of-use/" target="_blank">Terms of Use</a> and <a href="https://springbot.com/privacy-policy-2/" target="_blank">Privacy Policy</a>.
            </label>
          </div>
          <div *ngIf="agreeToTerms.invalid && (agreeToTerms.dirty || agreeToTerms.touched)" class="invalid-feedback">
            <span *ngIf="agreeToTerms.errors?.required">
              You must agree to the Terms of Use and Privacy Policy to continue.
            </span>
          </div>
        </div>

        <button class="btn btn-success w-100 mt-2" style="font-size:16px;" [disabled]="loading || signupForm.invalid">Get Started for Free</button>

        <div class="mt-2 row">
          <div class="col-md-6">Already have an account? <a routerLink="/login">Sign in</a></div>
          <div class="col-md-6 text-right">
            <a href="https://help.springbot.com/en/articles/10683383-registration-requirements-for-springbot-ecommerce" target="_blank">
              <fa-icon [icon]="['fas', 'question-circle']"></fa-icon>
              Have questions?
            </a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
